import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/_App/Navbar";
import Footer from "../components/_App/Footer";
import useGlobalSettings from "../hooks/useGlobalSettings";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import Preloader from "../components/_App/Preloader";


export default function MainLayout() {
  useEffect(() => {
    AOS.init()
  }, [])
  const { globalData, loading } = useGlobalSettings();

  const faviconUrl = globalData?.favicon?.url
    ? `${process.env.REACT_APP_UPLOAD_URL}${globalData.favicon.url}`
    : null;

  if (loading || !globalData) return <Preloader />;


  return (
    <>
      <Helmet>
        {faviconUrl && (
          <link rel="icon" type="image/png" href={`${faviconUrl}?v=${Date.now()}`} key="dynamic-favicon" />
        )}
        <title>{globalData?.defaultSeo?.metaTitle || globalData?.siteName}</title>
        <meta name="description" content={globalData?.defaultSeo?.metaDescription || "Default meta description"} />
      </Helmet>
      <Navbar data={globalData} />
      <main>
        <Outlet />
      </main>
      <Footer data={globalData} />
    </>
  );
}
